import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemProjectInfoEngagement } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemProjectInfoEngagement';

/**
 * 프로젝트 링크인 경우 추가 정보 (우리 사이트 내부 링크)
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemProjectInfo = {
  /** 프로젝트 참여 통계 */
  engagement?: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemProjectInfoEngagement;
  /** 프로젝트 ID */
  projectId?: number;
};
